import pcsb from "../images/pcsb.png";
import debsoc from "../images/debsoc.png";
import pnab from "../images/pnab.png";
import pict from "../images/pict_logo.png";

export const organizationsData = [
  {
    date: "JUNE 2023 - JUNE 2024",
    position: "Student Head",
    name: "Training & Placement Cell",
    logo: pict,
  },{
    date: "FEBRUARY 2021 - May 2024",
    position: "Member",
    name: "PICT CSI Student Branch (PCSB)",
    logo: pcsb,
  },
  {
    date: "SEPTEMBER 2021 - AUGUST 2022",
    position: "Design Head",
    name: "PICT NEWSLETTER and BROCHURE (PNAB), PICT",
    logo: pnab,
  },
  {
    date: "December 2021 - AUGUST 2022",
    position: "Design Head",
    name: "PICT Official DEBATE Society (DEBSOC)",
    logo: debsoc,
  },
];
